"use client";

import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
  type ReactNode,
} from "react";

interface SignupDialogContextValue {
  open: boolean;
  openSignupDialog: () => void;
  closeSignupDialog: () => void;
  setOpen: (open: boolean) => void;
}

const SignupDialogContext = createContext<SignupDialogContextValue | null>(null);

export function SignupDialogProvider({ children }: { children: ReactNode }) {
  const [open, setOpen] = useState(false);
  const openSignupDialog = useCallback(() => setOpen(true), []);
  const closeSignupDialog = useCallback(() => setOpen(false), []);

  const value = useMemo<SignupDialogContextValue>(
    () => ({ open, openSignupDialog, closeSignupDialog, setOpen }),
    [open, openSignupDialog, closeSignupDialog],
  );

  return (
    <SignupDialogContext.Provider value={value}>
      {children}
    </SignupDialogContext.Provider>
  );
}

export function useSignupDialog(): SignupDialogContextValue {
  const ctx = useContext(SignupDialogContext);
  if (!ctx) {
    throw new Error("useSignupDialog must be used within a SignupDialogProvider");
  }
  return ctx;
}
